"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentName = void 0;
/**
 * List of environment names
 *
 * @public
 * @constant
 */
var EnvironmentName;
(function (EnvironmentName) {
    EnvironmentName["STG"] = "STG";
    EnvironmentName["QA"] = "QA";
    EnvironmentName["PROD"] = "PROD";
})(EnvironmentName = exports.EnvironmentName || (exports.EnvironmentName = {}));
//# sourceMappingURL=environment-names.js.map